
























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import MonitoringTransfusiSvc from "@/services/MonitoringTransfusiService";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

@Component({
  components: { VCDateTimePicker }
})
export default class MonitoringTransfusiFinalisasi extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  // Finalisasi
  savingFinalisasi = false;
  savingSelesai = false;
  finForm: any = {};

  // Signature
  showSignDialog = false;
  signRole = "";
  signPassword = "";
  showPassword = false;
  signing = false;
  signError = "";

  // Stop
  showStopDialog = false;
  stopReason = "";
  savingStop = false;

  kesimpulanOptions = [
    { text: "Selesai Baik", value: "selesai_baik" },
    { text: "Dihentikan (Reaksi)", value: "dihentikan_reaksi" },
    { text: "Dihentikan (Lainnya)", value: "dihentikan_lainnya" },
  ];

  @Watch("monitoring", { immediate: true })
  onMonitoringChange() {
    if (this.monitoring) {
      this.finForm = {
        hb_post_transfusi: this.monitoring.hb_post_transfusi,
        volume_diberikan_ml: this.monitoring.volume_diberikan_ml,
        kesimpulan: this.monitoring.kesimpulan || "selesai_baik",
        catatan: this.monitoring.catatan,
        selesai_at: this.srvToLocal(this.monitoring.selesai_at),
      };
    }
  }

  srvToLocal(val: any): string | null {
    if (!val) return null;
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return null;
    return `${toDateString(d)} ${toTimeString(d)}:00`;
  }

  get selesaiAtDate(): Date | null {
    return composeDate(this.finForm.selesai_at, (this.finForm.selesai_at || "").slice(11, 16));
  }
  set selesaiAtDate(val: Date | null) {
    this.$set(
      this.finForm,
      "selesai_at",
      val ? `${toDateString(val)} ${toTimeString(val)}:00` : null
    );
  }

  get deltaHbDisplay(): string {
    if (!this.monitoring.hb_pre_transfusi || !this.finForm.hb_post_transfusi) return "-";
    const delta = (this.finForm.hb_post_transfusi - this.monitoring.hb_pre_transfusi).toFixed(1);
    return (parseFloat(delta) >= 0 ? "+" : "") + delta + " g/dL";
  }

  get deltaHbColor(): string {
    if (!this.monitoring.hb_pre_transfusi || !this.finForm.hb_post_transfusi) return "";
    const delta = this.finForm.hb_post_transfusi - this.monitoring.hb_pre_transfusi;
    return delta >= 0 ? "green--text" : "red--text";
  }

  async selesaiTransfusi() {
    this.savingSelesai = true;
    try {
      const resp = await MonitoringTransfusiSvc.selesaiTransfusi(this.monitoring.id, {
        selesai_at: this.finForm.selesai_at,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Transfusi selesai");
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.savingSelesai = false;
  }

  async simpanFinalisasi() {
    this.savingFinalisasi = true;
    try {
      const resp = await MonitoringTransfusiSvc.finalisasi(this.monitoring.id, this.finForm);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Finalisasi berhasil");
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.savingFinalisasi = false;
  }

  async stopTransfusi() {
    if (!this.stopReason.trim()) {
      alert("Alasan penghentian harus diisi");
      return;
    }
    this.savingStop = true;
    try {
      const resp = await MonitoringTransfusiSvc.finalisasi(this.monitoring.id, {
        kesimpulan: "dihentikan_lainnya",
        catatan: this.stopReason,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Transfusi dihentikan");
        this.showStopDialog = false;
        this.stopReason = "";
        this.$emit("saved");
      }
    } catch {
      // handled
    }
    this.savingStop = false;
  }

  // Signature methods
  openSign(role: string) {
    this.signRole = role;
    this.signPassword = "";
    this.signError = "";
    this.showSignDialog = true;
  }

  closeSign() {
    this.showSignDialog = false;
    this.signRole = "";
    this.signPassword = "";
    this.signError = "";
  }

  async doSign() {
    if (!this.signPassword) {
      this.signError = "Password harus diisi";
      return;
    }
    this.signing = true;
    this.signError = "";
    try {
      const resp = await MonitoringTransfusiSvc.sign(this.monitoring.id, {
        role: this.signRole,
        password: this.signPassword,
      });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay(resp.data.message);
        this.closeSign();
        this.$emit("saved");
      }
    } catch (err) {
      this.signError = err?.response?.data?.message || "Tanda tangan gagal";
    }
    this.signing = false;
  }

  formatDateTime(val: string) {
    if (!val) return "-";
    return moment(val).format("DD/MM/YYYY HH:mm");
  }
}
